export default function useColumnChartOptions() {
    return {
        chart: {
            type: 'column',
        },
        plotOptions: {
            column: {
                pointPadding: 0,
            },
        },
        xAxis: {
            tickInterval: 1,
            labels: {
                allowOverlap: true,
                style: {
                    fontSize: '0.65em',
                },
                distance: 1,
            },
        },
        yAxis: {
            title: {
                text: '',
            },
            allowDecimals: false,
        },
    };
}
